import p from "./ghl-ui.es1202.js";
import k from "./ghl-ui.es1192.js";
import { changeColor as x } from "./ghl-ui.es936.js";
const g = (d) => {
  const {
    baseColor: l,
    inputColorDisabled: a,
    cardColor: c,
    modalColor: i,
    popoverColor: s,
    textColorDisabled: e,
    borderColor: r,
    primaryColor: o,
    textColor2: b,
    fontSizeSmall: t,
    fontSizeMedium: C,
    fontSizeLarge: h,
    borderRadiusSmall: m,
    lineHeight: n
  } = d;
  return Object.assign(Object.assign({}, p), {
    labelLineHeight: n,
    fontSizeSmall: t,
    fontSizeMedium: C,
    fontSizeLarge: h,
    borderRadius: m,
    color: l,
    colorChecked: o,
    colorDisabled: a,
    colorDisabledChecked: a,
    colorTableHeader: c,
    colorTableHeaderModal: i,
    colorTableHeaderPopover: s,
    checkMarkColor: l,
    checkMarkColorDisabled: e,
    checkMarkColorDisabledChecked: e,
    border: `1px solid ${r}`,
    borderDisabled: `1px solid ${r}`,
    borderDisabledChecked: `1px solid ${r}`,
    borderChecked: `1px solid ${o}`,
    borderFocus: `1px solid ${o}`,
    boxShadowFocus: `0 0 0 2px ${x(o, {
      alpha: 0.3
    })}`,
    textColor: b,
    textColorDisabled: e
  });
}, f = {
  name: "Checkbox",
  common: k,
  self: g
}, S = f;
export {
  S as default,
  g as self
};
